import { createFileRoute } from "@tanstack/react-router";

import Transactions from "@/features/transactions/company";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/transaktionen/",
)({
  component: TransactionsPage,
  staticData: {
    breadcrumb: ["bank.link"],
  },
});

function TransactionsPage() {
  return <Transactions />;
}
